// removed by extract-text-webpack-plugin
module.exports = {"overlay":"mobileNavSearchResults__overlay__6a0657ec","results":"mobileNavSearchResults__results__6a0657ec","title":"mobileNavSearchResults__title__6a0657ec","item":"mobileNavSearchResults__item__6a0657ec"};


//////////////////
// WEBPACK FOOTER
// ./src/components/MobileNav/MobileNavSearchResults/mobileNavSearchResults.scss
// module id = ./src/components/MobileNav/MobileNavSearchResults/mobileNavSearchResults.scss
// module chunks = 4